import { AppAuthService } from './../../auth/auth.service';
import { Component, Host } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { AppComponent } from './../../app.component';

const AUTH_STORED_KEY: string = 'elzeviroUserLogin';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  invalidLogin: boolean;
  userid: string;
  password: string;
  rememberme: boolean;
  loading: boolean;
  hide: boolean = true;

  getTitle(): string {
    return "login";
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public authService: AppAuthService,
    public parent: AppComponent) {
  }

  ngOnInit() {
    this.loadAuth();
  }

  loadAuth() {
    let wo: any = localStorage.getItem(AUTH_STORED_KEY);
    if (wo) {
      wo = JSON.parse(wo);
      this.userid = wo.userid;
      this.password = wo.password;
      this.rememberme = true;
    }
  }
  saveAuth() {
    if (this.rememberme) {
      localStorage.setItem(AUTH_STORED_KEY, JSON.stringify({
        userid: this.userid,
        password: this.password
      }));
    } else {
      this.removeAuth()
    }
  }
  removeAuth() {
    localStorage.removeItem(AUTH_STORED_KEY);
  }

  toast() {
    let that = this;
    this.parent.addToast('login', 'toast test', function(wid) {
      console.log(wid)
      setTimeout(function() {
        that.parent.clearToast(wid);
      }, 2000);
    });
  }

  pinghttps() {
    console.log('============== pinghttps')
    this.authService.pinghttps()
      .subscribe(result => {
        console.log(result)
      })
  }


  signIn(credentials) {
    console.log('============== signIn')
    console.log(credentials)
    this.loading = true;
    this.authService.login(credentials)
      .subscribe(result => {
        console.log('============== signIn')
        console.log(result)
        if (result.success) {
          this.saveAuth();
          this.router.navigate(['/']);
        }
        else {
this.parent.operSnackBar(false, 'e-mail e/o password non validi')
          this.invalidLogin = true;
        }
        this.loading = false;
      })
  }

  socialSignIn(provider) {
    this.loading = true;
    this.authService.socialLogin(provider)
      .subscribe(result => {
        console.log('============== socialSignIn')
        if (result.success) {
          this.router.navigate(['/']);
        }
        else {
          let wmsg = result.credentials ? result.credentials.userid + ' non è un account abilitato' : 'account non valido';
          this.parent.operSnackBar(false, wmsg)
          this.invalidLogin = true;
        }
        this.loading = false;
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts